import { render, staticRenderFns } from "./RightMenuBase.vue?vue&type=template&id=16c4fd70&"
import script from "./RightMenuBase.vue?vue&type=script&lang=js&"
export * from "./RightMenuBase.vue?vue&type=script&lang=js&"
import style0 from "./RightMenuBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports